import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { confirmDialog } from "primereact/confirmdialog";

// ------------------ COMPONENTES DE BASE--------------------------------
import { useForm } from "../../../../../Base/Hooks/useForm";
import Loader from "../../../../../Base/Components/Loader/Loader";
import { toastShow } from "../../../../../Base/Services/ToastService";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import { getDateTimeStringSQL } from "../../../../../Base/Services/Moment/Luxon";
import AgGrid from "../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { getAreas } from "../../../../../Base/API/Global/Areas/AreasRequests";
import { ObtenerCurrency } from "../../../../../Base/API/Global/Currency/CurrencyRequest";
import { getAgentesCompras } from "../../../../../Base/API/IT/Accesos/AccesosRequests";
import { getTypesCategoria } from "../../../../../Base/API/Global/Types/TypeRequest";

// ------------------- CONSULTAS A LA API--------------------------------
import { getBodegasAct } from "../../../../../API/Suministros/SuministrosRequest";
import {
  getTermTypePaymentTerms,
  getTermIncoTerms,
} from "../../../../../API/Compras/Terms/TermsRequest";
import { getEstadosCategory } from "../../../../../API/Global/Status/StatusRequests";
import { getCustomersDetails } from "../../../../../API/Compras/Customers/CustomerDetails/CustomerDetailsRequest";
import { getCustomersAct } from "../../../../../API/Compras/Customers/CustomerRequests";
import { getProveedorAct } from "../../../../../API/Compras/Proveedores/ProveedoresRequest";
import {
  obtenerOrdenCompra,
  obtenerNumeroOrden,
  GuardarOrden,
  cambiarEstadoOrdenDetalle,
  EditarOrden,
  obtenerDetalleOrdenCompraOC,
} from "../../../../../API/Compras/Ordenes/OrdenesComprasRequests";
import { getPurchaseRequestDetailAuth } from "../../../../../API/Compras/Requisas/PurchaseRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import ItemOverlayPanel from "./ItemOverlayPanel";
import EncabezadoOrdenesCompras from "./EncabezadoOrdenesCompras";
import CrudRequisa from "../../Requisas/CrudRequisa/CrudRequisa";

const OrdenesComprasCrud = ({
  PurchaseOrder = undefined,
  setOrderToShow = () => {},
  habilitar,
  setHabilitar = () => {},
  actualizarComprasScreen = () => {},
  ordenDialog,
  setOrdenDialog = () => {},
}) => {
  const dtAutorizarRequisa = useRef();
  const overlayItemRef = useRef();
  const { userAuth } = useContext(AuthContext);
  const toast = useRef();

  const [permisoCostos] = useState(
    userAuth.AccessWeb.split(",")
      .map((e) => parseInt(e))
      .includes(29),
  );

  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [clienteDetalles, setClienteDetalles] = useState([]);
  const [detalleOrdenCompra, setDetalleOrdenCompra] = useState([]);
  const [inputValues, setinputValues] = useState({});
  const [numeroOrden, setNumeroOrden] = useState("");
  const [requisasAgregadas, setRequisasAgregadas] = useState([]);
  const [botonReporteHabilitado, setBotonReporteHabilitado] = useState(false);
  const [requisaToShow, setRequisaToShow] = useState([]);
  const [requisaDialog, setRequisaDialog] = useState(false);

  const obtenerInfoInput = async (orden, nueva) => {
    setLoading(true);
    const proveedores = await getProveedorAct();
    const agentesCompras = await getAgentesCompras();
    const areas = await getAreas();
    const monedas = await ObtenerCurrency();
    const customers = await getCustomersAct();
    const terminos = await getTermTypePaymentTerms();
    const estados = await getEstadosCategory("PurchaseRequests");
    const tipos = await getTypesCategoria("PurchaseRequests");
    const warehouses = await getBodegasAct();
    const terminosInco = await getTermIncoTerms();
    const customersDetaill = await getCustomersDetails(
      values.Cliente?.IdCustomer,
    );

    const val = {
      AgentesCompras: agentesCompras,
      Areas: areas,
      Monedas: monedas,
      Estados: estados,
      Terminos: terminos,
      TipoCompras: tipos,
      Warehouses: warehouses,
      Proveedores: proveedores,
      Clientes: customers,
      TerminosInco: terminosInco,
    };
    setinputValues(val);

    // if ((PurchaseOrder && !nueva) || req.PurchaseOrder) {
    if (PurchaseOrder && !nueva) {
      handleInputChange({
        target: { name: "PurchaseOrder", value: PurchaseOrder },
      });
      getInfo(PurchaseOrder, val);
    } else {
      const numOrden = await obtenerNumeroOrden();
      setNumeroOrden(numOrden[0].PurchaseOrder);
      setDetalleOrdenCompra([]);
      if (numOrden.length > 0) {
        let tempo = null;
        if ([25, 26].includes(userAuth.IdRol)) {
          tempo = agentesCompras.filter(
            (a) => a.IdPurchaseAgent === userAuth.IdUser,
          );
        }

        const agente = agentesCompras.filter(
          (a) => a.IdPurchaseAgent === userAuth.IdUser,
        );

        const Cliente = customers.filter((a) => a?.IdCustomer === 1);

        const ClienteDet = customersDetaill.filter(
          (a) => a?.IdCustomerDetails === 12,
        );

        setValues({
          ...initialValues,
          NumeroOrden: numOrden[0].PurchaseOrder,
          Agente: agente[0],
          RequiredDate: new Date(),
          RequiredDateH: new Date(),
          Date: new Date(),
          Estado: {
            IdStatus: 11,
            StatusCategory: "Purchase",
            StatusName: "Creada",
          },
        });
        setHabilitar(true);
      }
    }
    setLoading(false);
  };

  const resetForm = () => {
    setValues({
      ...initialValues,
      NumeroOrden: numeroOrden,
      Agente: userAuth.UserName,
      RequiredDate: new Date(),
      RequiredDateH: new Date(),
      Date: new Date(),
      Estado: {
        IdStatus: 11,
        StatusCategory: "Purchase",
        StatusName: "Creada",
      },
      Comment: "", // Limpiar la descripción
    });
    setClienteDetalles([]);
    setSelected([]);
    setHabilitar(true);
  };

  const actualizarCompras = async (NoOrden) => {
    setLoading(true);
    let oc = NoOrden ? NoOrden.PurchaseOrder : values.PurchaseOrde;
    handleInputChange({
      target: { name: "PurchaseOrder", value: oc },
    });
    getInfo(oc);
    setLoading(false);
  };

  const initialValues = {
    IdPurchaseOrder: -1,
    NumeroOrden: numeroOrden,
    Date: new Date(),
    Estado: {
      IdStatus: 11,
      StatusCategory: "Purchase",
      StatusName: "Creada",
    },
    SubTotal: 0,
    Discount: 0,
    TAX: 0,
    Freights: 0,
    Otros: 0,
    Total: 0,
    // ClienteDetalle: { Address: '' },
    Pro: false,
  };
  const { values, handleInputChange, setValues, setNumber } =
    useForm(initialValues);

  const getInfo = async (id, val = inputValues) => {
    setLoading(true);
    let PO = id === PurchaseOrder ? PurchaseOrder : id;
    const infoPurchaseOrder = await obtenerOrdenCompra(PO);

    if (infoPurchaseOrder.length === 0) {
      toastShow(
        toast,
        "warn",
        "Orden no encontrada",
        "La orden de compra que desea buscar no existe.",
      );
      setLoading(false);
      setSelected([]);
      setDetalleOrdenCompra([]);
      setHabilitar(true);
      resetForm();
    } else {
      asignarValores(infoPurchaseOrder[0], val);
      setOrderToShow(infoPurchaseOrder[0].PurchaseOrder);
      setHabilitar(false);
      setSelected([]);
    }
    setLoading(false);
  };

  const getDetalleCliente = async (IdCustomer) => {
    const tempo = await getCustomersDetails(IdCustomer);
    return tempo;
  };

  const asignarValores = async (encabezadoOC, inputValues) => {
    setLoading(true);
    console.log("========== TIPO COMPRA DEBUG ==========");
    console.log("IdType guardado en la OC:", encabezadoOC.IdType);
    console.log("Tipo del IdType OC:", typeof encabezadoOC.IdType);
    console.log("Lista TipoCompras:", inputValues.TipoCompras);
    console.log(
      "Ids disponibles:",
      inputValues.TipoCompras?.map(item => ({
        IdType: item.IdType,
        Type: item.Type,
        tipoId: typeof item.IdType
      }))
    );

    let proveTempo = inputValues.Proveedores.filter(
      (item) => item.IdVendor === encabezadoOC.IdVendor,
    );
    let clienteTempo = inputValues.Clientes.filter(
      (item) => item.IdCustomer === encabezadoOC.IdCustomer,
    );
    let agenteTempo = inputValues.AgentesCompras.filter(
      (item) => item.IdPurchaseAgent === encabezadoOC.IdUser,
    );
    let areaTempo = inputValues.Areas.filter(
      (item) => item.IdArea === encabezadoOC.IdArea,
    );
    let estadoTempo = inputValues.Estados.filter(
      (item) => item.IdStatus === encabezadoOC.IdStatus,
    );
    let monedaTempo = inputValues.Monedas.filter(
      (item) => item.IdCurrency === encabezadoOC.IdCurrency,
    );
    let terminoTempo = inputValues.Terminos.filter(
      (item) => item.IdTerm === encabezadoOC.PaymentTerms,
    );
    let terminoInco = inputValues.TerminosInco.filter(
      (item) => item.IdTerm === encabezadoOC.IncoTerms,
    );
    let tipoCompraTempo = inputValues.TipoCompras.filter(
      (item) => item.IdType === encabezadoOC.IdType,
    );
    console.log("Tipo Compra encontrado:", tipoCompraTempo);
    console.log("=======================================");

    let warehouseTempo = inputValues.Warehouses.filter(
      (item) => item.IdBodega === encabezadoOC.IdBodega,
    );
    let detallesCliente = await getDetalleCliente(clienteTempo[0]?.IdCustomer);
    let clienteDetalleTempo = detallesCliente.filter(
      (item) => item.IdCustomerDetails === encabezadoOC.IdCustomerDetails,
    );

    const values = {
      IdPurchaseOrder: encabezadoOC.IdPurchaseOrder,
      NumeroOrden: encabezadoOC.PurchaseOrder,
      Proveedor: proveTempo[0],
      Cliente: clienteTempo[0],
      Agente: agenteTempo[0],
      Date: new Date(encabezadoOC.OrderDate),
      Termino: terminoTempo[0],
      TerminoInco: terminoInco[0],
      Estado: estadoTempo[0],
      TipoCompra: tipoCompraTempo[0],
      Area: areaTempo[0],
      Bodega: warehouseTempo[0],
      Moneda: monedaTempo[0],
      Comment: encabezadoOC.Description,
      SubTotal: encabezadoOC.SubTotal,
      Discount: encabezadoOC.Discount,
      TAX: encabezadoOC.TAX,
      Freights: encabezadoOC.Freights,
      Otros: encabezadoOC.Otros,
      Total: encabezadoOC.Total,
      ClienteDetalle: clienteDetalleTempo[0],
      Pro: false,
      TipoDescuento: null,
      RequiredDate: new Date(encabezadoOC.RequiredDate),
      RequiredDateH: new Date(encabezadoOC.RequiredDateH),
    };
    setValues(values);
    getDetalleCompra(encabezadoOC.PurchaseOrder);
  };

  //Obtiene los detalles de la orden de compras
  const getDetalleCompra = async (PurchaseOrder) => {
    const detalles = await obtenerDetalleOrdenCompraOC(PurchaseOrder);
    setDetalleOrdenCompra(detalles.filter((i) => i?.IdStatus !== 15));
    setLoading(false);
  };

  // VERIFICA LOS CAMPOS DEL ENCABEZADO PARA SI SON VALIDOS AGREGA UNA NUEVA FILA AL DETALLE
  const verificarCamposEncabezado = () => {
    let error = false;
    switch (true) {
      case values.Proveedor === null || values.Proveedor === undefined:
        toastShow(toast, "warn", "Error", "Seleccione un proveedor.");
        error = true;
        break;
      // case values.Cliente === null || values.Cliente === undefined:
      //   toastShow(toast, "warn", "Error", "Seleccione un cliente.");
      //   error = true;
      //   break;
      case values.Agente === null || values.Agente === undefined:
        toastShow(toast, "warn", "Error", "Seleccione un Agente.");
        error = true;
        break;
      case values.Termino === null || values.Termino === undefined:
        toastShow(toast, "warn", "Error", "Seleccione un termino de compras.");
        error = true;
        break;
      // case values.TerminoInco === null || values.TerminoInco === undefined:
      //   toastShow(toast, "warn", "Error", "Seleccione un termino de compras.");
      //   error = true;
      //   break;
      case values.TipoCompra === null || values.TipoCompra === undefined:
        toastShow(toast, "warn", "Error", "Seleccione el tipo de compra.");
        error = true;
        break;
      case values.Area === null || values.Area === undefined:
        toastShow(toast, "warn", "Error", "Seleccione un area.");
        error = true;
        break;
      case values.Moneda === null || values.Moneda === undefined:
        toastShow(toast, "warn", "Error", "Seleccione una moneda.");
        error = true;
        break;
      // case values.ClienteDetalle === null ||
      //   values.ClienteDetalle === undefined:
      //   toastShow(toast, "warn", "Error", "Seleccione una entrega.");
      //   error = true;
      //   break;
      default:
        error = false;
        break;
    }
    return error;
  };

  const addRequisas = (infoRequisas) => {
    let RequisasExistente = detalleOrdenCompra.some((i) =>
      infoRequisas.some((f) => f.IdProduct === i.IdComponent),
    );

    if (RequisasExistente) {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "No se permiten valores repetidos",
      );
    } else {
      let dataNueva = [];
      infoRequisas.forEach((f) => {
        let Id = (detalleOrdenCompra.length + dataNueva.length + 1) * -1;
        dataNueva.push({
          IdPurchaseOrderDetail: Id,
          FechaCreado: new Date(),
          PurchaseRequest: f.PurchaseRequest,
          IdPurcharesRequestDetail: f.IdPurcharesRequestDetail,
          IdComponent: f.IdProduct,
          IdCategory: f.IdCategoria,
          IdSubCategoria: f.IdSubCategoria,
          IdTipoProducto: f.IdTipoProducto,
          IdTipoIngreso: f.IdType,
          IdCurrency: f.IdCurrency,
          IdVendor: f.IdVendor,
          NombreProducto: f.NombreProducto,
          NombreTipoProducto: f.NombreTipoProducto,
          Description: f.DescripcionProducto,
          NombreCategoria: f.NombreCategoria,
          NombreSubcategoria: f.NombreSubcategoria,
          IdUnit: f.IdUnit,
          UnitSimbol: f.UnitSimbol,
          UnitName: f.UnitSimbol,
          Type: f.Type,
          IdBodega: f.IdBodega,
          NombreBodega: f.NombreBodega,
          IdEstante: f.IdEstante,
          NombreEstante: f.NombreEstante,
          IdPosicion: f.IdPosicion,
          NombrePosicion: f.NombrePosicion,
          CurrencySymbol: f.CurrencySymbol,
          UserName: f.UserNameAgente,
          Usuario: f.Usuario,
          IdStatus: 20,
          Estado: "En OC",
          CodigoProducto: f.CodigoProducto,
          Quantity: f.Quantity,
          UnitPrice: f.Price,
          SubTotal: f.SubTotal,
          Discount: f.Discount,
          TAX: f.TAX,
          ISV18: f.ISV18,
          Total: f.Total,
        });
      });

      let nuevoArreglo = [...detalleOrdenCompra, ...dataNueva];

      const isAnyOrderCanceled = detalleOrdenCompra.some(
        (detalle) => detalle.IdStatus === 15,
      );

      if (detalleOrdenCompra.length > 0) {
        const monedasDiferentes = nuevoArreglo.some((nuevo) =>
          detalleOrdenCompra.some(
            (detalle) => detalle.IdCurrency !== nuevo.IdCurrency,
          ),
        );

        const proveedoresDiferentes = nuevoArreglo.some((nuevo) =>
          detalleOrdenCompra.some(
            (detalle) => detalle.IdVendor !== nuevo.IdVendor,
          ),
        );

        if (!isAnyOrderCanceled) {
          if (monedasDiferentes) {
            toastShow(
              toast,
              "warn",
              "Error",
              "No se puede agregar requisas con monedas diferentes",
            );
            return;
          }
          if (proveedoresDiferentes) {
            toastShow(
              toast,
              "warn",
              "Error",
              "No se puede agregar requisas con proveedores diferentes",
            );
            return;
          }
        }

        setDetalleOrdenCompra(nuevoArreglo);
      } else {
        setDetalleOrdenCompra(nuevoArreglo);
      }
    }
  };

  const resetTable = () => {
    let Subtotal = 0;
    let descuento = 0;
    let total = 0;
    let TAX = 0;
    let ISV18 = 0;
    detalleOrdenCompra.forEach((detalle) => {
      Subtotal += detalle?.Quantity * detalle?.UnitPrice;
      descuento += detalle?.Discount;
      TAX += detalle?.TAX;
      total += detalle?.Total;
      ISV18 += detalle?.ISV18;
    });
    // dtAutorizarRequisa.current.reset();

    setValues({
      ...values,
      SubTotal: Subtotal || 0,
      Discount: descuento || 0,
      Total: total,
      TAX: TAX || 0,
      ISV18: ISV18 || 0,
    });
    return true;
  };

  const addNewRow = () => {
    if (verificarCamposEncabezado() === false) {
      if (
        detalleOrdenCompra[detalleOrdenCompra.length - 1]?.IdComponent !== null
      ) {
        let IdDet = -(detalleOrdenCompra?.length + 1);
        const detalles = [
          ...detalleOrdenCompra,
          {
            FechaCreado: new Date(),
            Estado: "En OC",
            IdStatus: 20,
            IdComponent: null,
            IdPurchaseOrderDetail: IdDet, // -1 * parseInt((+new Date().getTime() + "").substring(9, 14)),
            PurchaseRequest: "",
            NombreProducto: "",
            Description: "",
            IdType: null,
            Type: "",
            IdVendor: values.Proveedor.IdVendor,
            IdCurrency: values.Moneda.IdCurrency,
            CurrencySymbol: "",
            IdUnit: null,
            UnitSimbol: "",
            IdRequest: null,
            IdCategory: null,
            NombreCategoria: "",
            IdSalesOrder: null,
            SalesOrder: "",
            IdSubCategoria: null,
            KgsPR: 0,
            Quantity: 0,
            QtyCalculated: 0,
            QtyReceive: 0,
            UnitPrice: 0,
            SubTotal: 0,
            Discount: 0,
            TAX: 0,
            Total: 0,
            IdPurcharesRequestDetail: 0,
          },
        ];
        setDetalleOrdenCompra(detalles);
      } else {
        toastShow(toast, "warn", "Error", "Se debe de seleccionar un item.");
      }
    }
  };

  //AGREGAR ORDEN Y DETALLE DE ORDEN
  const guardarEncabezado = async () => {
    if (verificarCamposEncabezado() === false) {
      if (detalleOrdenCompra.length === 0) {
        toastShow(
          toast,
          "error",
          "Error al guardar",
          "Es necesario agregar al menos un detalle de orden.",
        );
        return;
      }
      // setLoading(true);

      const bodyEncabezado = {
        // IdPurchaseOrder: values.IdPurchaseOrder,
        PurchaseOrder: values.NumeroOrden,
        // IdCustomer: values.Cliente.IdCustomer,
        // IdVendor: values.Proveedor.IdVendor,
        IdVendor: detalleOrdenCompra[0]?.IdVendor,
        PaymentTerms: values.Termino.IdTerm,
        // IdCurrency: values.Moneda.IdCurrency,
        IdCurrency: detalleOrdenCompra[0]?.IdCurrency,
        IdArea: values.Area.IdArea,
        IdStatus: values.Estado.IdStatus,
        OrderDate: getDateTimeStringSQL(values.Date),
        IdUserCreate: values.Agente.IdPurchaseAgent,
        Description: values.Comment,
        IdUnit: null,
        IdType: values.TipoCompra.IdType,
        RequiredDate: getDateTimeStringSQL(values.RequiredDate),
        RequiredDateH: getDateTimeStringSQL(values.RequiredDateH),
        SubTotal: values.SubTotal,
        Discount: values.Discount,
        TAX: values.TAX,
        ISV18: values.ISV18,
        Freights: values.Freights,
        Otros: values.Otros,
        Total: values.Total,
        // IdCustomerDetails: values.ClienteDetalle.IdCustomerDetails,
        IncoTerms: values.TerminoInco.IdTerm,
      };

      // console.log(bodyEncabezado)

      const detalleOrden = detalleOrdenCompra.map((detalle) => ({
        ...detalle[0],
        IdPurchaseOrder: values.IdPurchaseOrder,
        IdStatus: detalle.IdStatus,
        IdProducto: detalle.IdComponent,
        IdUnit: detalle.IdUnit,
        IdSubCategoria: detalle.IdSubCategoria,
        Description: detalle.Description,
        Quantity: detalle.Quantity,
        QtyReceive: detalle.QtyReceive,
        Balance: detalle.Quantity,
        FechaCreado: getDateTimeStringSQL(detalle.FechaCreado),
        UnitPrice: detalle.UnitPrice,
        SubTotal: detalle.SubTotal,
        Discount: detalle.Discount,
        TAX: detalle.TAX,
        ISV18: detalle.ISV18,
        Total: detalle.Total,
        IdPurcharesRequestDetail: detalle.IdPurcharesRequestDetail,
      }));

      const respuestaDetalles = await GuardarOrden(
        bodyEncabezado,
        detalleOrden,
      );

      if (respuestaDetalles !== -1) {
        setHabilitar(false);
        toastShow(toast, "success", "Guardado", respuestaDetalles[0].MENSAJE);

        actualizarCompras(respuestaDetalles[0]);
        // obtenerInfoInput(respuestaDetalles[0]);
        actualizarComprasScreen();
        setBotonReporteHabilitado(true);
        setLoading(false);
      } else {
        toastShow(
          toast,
          "error",
          "Error al guardar",
          "Error al guardar detalles de la Orden.",
        );
        setLoading(false);
      }
    }
  };

  //EDITAR ORDEN Y DETALLE DE ORDEN
  const editarEncabezado = async () => {
    if (verificarCamposEncabezado() === false) {
      const primerDetalleValido = detalleOrdenCompra.find(
        (detalle) => detalle.IdStatus !== 15,
      );

      const bodyEncabezado = {
        IdPurchaseOrder: values.IdPurchaseOrder,
        PurchaseOrder: values.NumeroOrden,
        // IdCustomer: values.Cliente.IdCustomer,
        IdVendor: primerDetalleValido?.IdVendor,
        PaymentTerms: values.Termino.IdTerm,
        IdCurrency: primerDetalleValido?.IdCurrency,
        IdArea: values.Area.IdArea,
        IdStatus: values.Estado.IdStatus,
        IdUserCreate: values.Agente.IdPurchaseAgent,
        Description: values.Comment,
        IdUnit: null,
        IdType: values.TipoCompra.IdType,
        RequiredDate: getDateTimeStringSQL(values.RequiredDate),
        RequiredDateH: getDateTimeStringSQL(values.RequiredDateH),
        SubTotal: values.SubTotal,
        Discount: values.Discount,
        TAX: values.TAX,
        ISV18: values?.ISV18,
        Freights: values.Freights,
        Otros: values.Otros,
        Total: values.Total,
        // IdCustomerDetails: values.ClienteDetalle.IdCustomerDetails,
        IncoTerms: values.TerminoInco.IdTerm,
      };

      // Obtener los detalles de la orden de compra para editar
      const detalleOrden = detalleOrdenCompra.map((detalle) => ({
        ...detalle,
        IdPurchaseOrder: values.IdPurchaseOrder,
        IdStatus: detalle.IdStatus,
        IdProducto: detalle.IdComponent,
        IdUnit: detalle.IdUnit,
        IdSubCategoria: detalle.IdSubCategoria,
        Description: detalle.Description,
        Quantity: detalle.Quantity,
        QtyReceive: detalle.QtyReceive,
        Balance: detalle.Quantity,
        FechaCreado: getDateTimeStringSQL(detalle.FechaCreado),
        UnitPrice: detalle.UnitPrice,
        SubTotal: detalle.SubTotal,
        Discount: detalle.Discount,
        TAX: detalle.TAX,
        Total: detalle.Total,
        IdPurcharesRequestDetail: detalle.IdPurcharesRequestDetail,
        IdPurchaseOrderDetail: detalle.IdPurchaseOrderDetail,
        ISV18: detalle?.ISV18,
      }));

      // console.log(bodyEncabezado)
      // setLoading(false)
      // Llamar a la función para editar la orden de compra
      const respuestaDetalles = await EditarOrden(bodyEncabezado, detalleOrden);

      if (respuestaDetalles !== -1) {
        setHabilitar(false);
        toastShow(toast, "success", "Editado", "Orden editada exitosamente.");
        actualizarCompras({ PurchaseOrder: values.NumeroOrden });
        actualizarComprasScreen();
        setBotonReporteHabilitado(true);
        setLoading(false);
      } else {
        toastShow(
          toast,
          "error",
          "Error al editar",
          "Error al editar detalles de la Orden.",
        );
        setLoading(false);
      }
    }
  };

  //Cambiar estado del detalle de Orden a Cancelado
  const changeEstadoDetalle = () => {
    let tempo = [...detalleOrdenCompra];
    let canDelete = true; // Variable para verificar si se puede eliminar el detalle

    selected.forEach((select) => {
      // Verificar si el detalle tiene IdStatus 27 o IdStatus 23
      if (select.IdStatus === 27 || select.IdStatus === 23) {
        canDelete = false;
        toastShow(
          toast,
          "warn",
          "Error al eliminar",
          "No se puede eliminar el detalle porque existe un ingreso.",
        );
      } else {
        const index = tempo.findIndex(
          (detail) =>
            detail.IdPurchaseOrderDetail === select.IdPurchaseOrderDetail,
        );
        if (index >= 0) {
          tempo.splice(index, 1); // Elimina el elemento del arreglo
        }
      }
    });

    if (canDelete) {
      setDetalleOrdenCompra(tempo); // Actualiza el estado con el nuevo arreglo sin el elemento eliminado

      selected.forEach((select) => {
        cambiarEstadoOrdenDetalle(select);
      });
      // infoScreen();
      // obtenerInfoInput(null, null)
      toastShow(
        toast,
        "success",
        "Eliminado",
        "Detalle de orden de compra cancelado.",
      );
    }
  };

  const eliminarItemDetalle = (position) => {
    if (selected.length > 0) {
      confirmDialog({
        message: "Esta seguro que desea eliminar este item",
        header: "Cancelar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Si",
        accept: () => changeEstadoDetalle(),
        rejectLabel: "No",
        style: { backgroundColor: "white" },
      });
    } else {
      toastShow(
        toast,
        "warn",
        "Advertencia",
        "Seleccione al menos un detalle.",
      );
    }
  };

  const habilitarComponentes = () => {
    setHabilitar(true);
  };

  const nuevaRequisa = () => {
    confirmDialog({
      message: "Esta seguro que desea crear una nueva orden de compra",
      header: "Cancelar",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Si",
      accept: () => {
        // Limpia el formulario antes de obtener nueva información
        resetForm();
        setOrderToShow(null);
        obtenerInfoInput(false, true);
        setHabilitar(true);
      },
      rejectLabel: "No",
      style: { backgroundColor: "white" },
    });
  };

  const agregarDetalleRequisa = async (PurchaseRequest) => {
    if (verificarCamposEncabezado() === false) {
      if (requisasAgregadas.includes(PurchaseRequest?.IdPurchaseRequest)) {
        setRequisasAgregadas([
          ...requisasAgregadas,
          PurchaseRequest?.IdPurchaseRequest,
        ]);
      }

      let tempo = [];
      if (PurchaseRequest?.IdPurchaseRequest) {
        const detalles = await getPurchaseRequestDetailAuth(
          PurchaseRequest?.IdPurchaseRequest,
        );

        if (values.Proveedor !== null) {
          detalles.forEach((detalle) => {
            if (!verificarExiste(detalle)) {
              if (detalle.IdProveedor === values.Proveedor?.IdCustomer) {
                tempo.push({
                  IdPurchaseOrderDetail: -1,
                  FechaCreado: new Date(),
                  IdStatus: 20,
                  Estado: "En OC",
                  PurchaseRequest: detalle.PurchaseRequest,
                  CodigoProducto: detalle.CodigoProducto,
                  NombreProducto: detalle.NombreProducto,
                  Description: detalle.DescripcionProducto,
                  CurrencySymbol: detalle.CurrencySymbol,
                  Type: detalle.Type,
                  UnitSimbol: detalle.UnitSimbol,
                  NombreCategoria: detalle.NombreCategoria,
                  Quantity: detalle.Quantity,
                  UnitPrice: detalle.Price,
                  TAX: detalle.TAX,
                  Total: detalle.Total,
                  IdComponent: detalle.IdProduct,
                  IdUnit: detalle.IdUnit,
                  IdPurcharesRequestDetail: detalle.IdPurcharesRequestDetail,
                  IdSubCategoria: detalle.IdSubCategoria,
                });
              }
            }
          });
        } else {
          toastShow(toast, "warn", "Error", "Seleccione un Proveedor");
        }

        setDetalleOrdenCompra([...detalleOrdenCompra, ...tempo]);
        // Agregar el ID de la requisición al estado de requisasAgregadas
        setRequisasAgregadas([
          ...requisasAgregadas,
          PurchaseRequest?.IdPurchaseRequest,
        ]);
      } else {
        toastShow(toast, "warn", "Error", "Seleccione una requisa.");
      }
    }
  };

  const Functions = {
    addNewRow,
    guardarEncabezado,
    habilitarComponentes,
    eliminarItemDetalle,
    nuevaRequisa,
    getInfo,
    agregarDetalleRequisa,
    editarEncabezado,
    addRequisas,
    verificarCamposEncabezado,
  };

  const verificarExiste = (detalleToInsert) => {
    const existe = detalleOrdenCompra.some(
      (detalle) =>
        detalle.IdPurcharesRequestDetail ===
        detalleToInsert.IdPurcharesRequestDetail,
    );
    if (existe) {
      toastShow(toast, "warn", "Item ya esta agregado", "");
    }
    return existe;
  };

  const selectedItemChange = ({ data, api }, IdPurchaseOrderDetail) => {
    const index = detalleOrdenCompra.findIndex(
      (detail) => detail.IdPurchaseOrderDetail === IdPurchaseOrderDetail,
    );

    if (index === -1) {
      toastShow(toast, "error", "Error", "Detalle no encontrado");
      return;
    }

    const existe = detalleOrdenCompra.some(
      (detalle) => detalle.IdComponent === data?.IdProduct,
    );

    if (existe) {
      toastShow(toast, "error", "Error", "No se permiten Productos repetidos");
      return;
    }

    let tempo = [...detalleOrdenCompra];

    const updateDetail = (detail, data) => {
      detail.IdComponent = data.IdProduct;
      detail.PurchaseRequest = data.PurchaseRequest;
      detail.CodigoProducto = data.CodigoProducto;
      detail.NombreProducto = data.NombreProducto;
      detail.Description = data.Description;
      detail.CurrencySymbol = data.CurrencySymbol;
      detail.IdCurrency = data.IdCurrency;
      detail.Type = data.Type;
      detail.UnitSimbol = data.UnitSimbol;
      detail.NombreCategoria = data.NombreCategoria;
      detail.Quantity = data.Quantity;
      detail.UnitPrice = data.Price;
      detail.SubTotal = data.SubTotal;
      detail.Discount = data.Discount;
      detail.TAX = data.TAX;
      detail.ISV18 = data.ISV18;
      detail.Total = data.Total;
      detail.IdUnit = data.IdUnit;
      detail.IdSubCategoria = data.IdSubCategoria;
      detail.IdPurcharesRequestDetail = data.IdPurcharesRequestDetail;
      detail.IdVendor = data.IdVendor;
    };

    const isAnyOrderCanceled = tempo.some((detalle) => detalle.IdStatus === 15);

    if (detalleOrdenCompra.length > 0) {
      const monedasDiferentes = tempo.some(
        (detalle) =>
          detalle.IdCurrency !== data.IdCurrency &&
          detalle.IdPurchaseOrderDetail !== IdPurchaseOrderDetail,
      );

      const proveedoresDiferentes = tempo.some(
        (detalle) =>
          detalle.IdVendor !== data.IdVendor &&
          detalle.IdPurchaseOrderDetail !== IdPurchaseOrderDetail,
      );

      if (!isAnyOrderCanceled) {
        if (monedasDiferentes) {
          toastShow(
            toast,
            "warn",
            "Error",
            "No se puede agregar requisas con monedas diferentes",
          );
          return;
        }
        if (proveedoresDiferentes) {
          toastShow(
            toast,
            "warn",
            "Error",
            "No se puede agregar requisas con proveedores diferentes",
          );
          return;
        }
      }

      updateDetail(tempo[index], data);
      setDetalleOrdenCompra(tempo);
      overlayItemRef.current.hide();
      api.stopEditing();
    } else {
      updateDetail(tempo[index], data);
      setDetalleOrdenCompra(tempo);
      overlayItemRef.current.hide();
      api.stopEditing();
    }
  };

  const obtenerDetalleCustomer = async () => {
    let customersDetaill;
    if (values.Cliente?.IdCustomer) {
      customersDetaill = await getCustomersDetails(values.Cliente?.IdCustomer);
    } else {
      customersDetaill = [];
    }
    setinputValues({
      ...inputValues,
      ClientesDetalle: customersDetaill,
    });
  };

  const columns = [
    {
      // ID
      field: "IdPurchaseOrderDetail",
      header: "ID Detalle",
      headerEn: "ID Detail",
      className: "Xsmall",
      frozen: true,
      hidden: userAuth.IdRol === 1,
    },
    {
      // NUMERO REQUISA
      field: "PurchaseRequest",
      header: "No. Requisa",
      headerEn: "No. Requisition",
      className: "medium",
      frozen: "frozen",
      Format: "Modal",
      onCellDoubleClicked: ({ data }) => {
        RequisaC(data.PurchaseRequest);
        setHabilitar(false);
      },
    },
    {
      // FECHA CREADO
      field: "FechaCreado",
      header: "Fecha Creado",
      headerEn: "Date Create",
      className: "large",
      Format: "Date",
    },
    {
      // ESTADO
      field: "Estado",
      header: "Estado",
      headerEn: "Status",
      className: "small",
      body: (rowData) => ({ ID: rowData.IdStatus, Estado: rowData.Estado }),
      frozen: "frozen",
      alignFrozen: "left",
      Format: "Estado",
    },
    {
      field: "CodigoProducto",
      header: "Código de Producto",
      editable: ({ data }) => data.IdPurchaseOrderDetail < 0, // Solo editable cuando se crea una nueva orden
      cellEditor: ({ data }) => {
        return (
          <ItemOverlayPanel
            IdPurchaseOrderDetail={data.IdPurchaseOrderDetail}
            selectedItemChange={selectedItemChange}
            overlayItemRef={overlayItemRef}
            detalleOrdenCompra={detalleOrdenCompra}
            IdComponent={data.CodigoProducto}
            IdCurrency={values.Moneda.IdCurrency}
            IdVendor={values.Proveedor.IdVendor}
          />
        );
      },
      className: "medium",
      Sumary: "count",
    },
    {
      // PRODUCTO
      field: "NombreProducto",
      header: "Producto",
      headerEn: "Product",
      className: "XXXlarge",
    },
    {
      // DESCRIPCION PRODUCTO
      field: "Description",
      header: "Descripción Producto",
      headerEn: "Product Description",
      className: "XXXlarge",
    },
    {
      // MONEDA
      field: "CurrencySymbol",
      header: "Moneda",
      headerEn: "Currency",
      className: "small",
    },
    {
      // TIPO COMPRA
      field: "Type",
      header: "Tipo",
      headerEn: "Type",
      className: "medium",
    },
    {
      // UNIDAD
      field: "UnitSimbol",
      header: "Unidad",
      headerEn: "Unit",
      className: "Xsmall",
    },
    {
      // CATEGORIA
      field: "NombreCategoria",
      header: "Tipo Producto",
      headerEn: "Product Type",
      className: "medium",
    },
    {
      // CANTIDAD ORDENADO
      field: "Quantity",
      header: "Ordenado",
      headerEn: "Order",
      className: "Xsmall",
      Format: "Currency",
      frozen: "frozen",
      alignFrozen: "right",
      Sumary: "sum",
    },
    {
      // PRECIO
      field: "UnitPrice",
      header: "Precio",
      headerEn: "Price",
      className: "small",
      Format: "Currency",
      frozen: "frozen",
      alignFrozen: "right",
      hidden: permisoCostos,
    },
    {
      // DESCUENTO
      field: "Discount",
      header: "Descuento",
      headerEn: "Discount",
      className: "Xsmall",
      Format: "Currency",
      frozen: "frozen",
      Sumary: "sum",
      alignFrozen: "right",
      hidden: permisoCostos,
    },
    {
      // ISV
      field: "TAX",
      header: "ISV 15%",
      headerEn: "TAX 15%",
      className: "Xsmall",
      Format: "Currency",
      sortable: true,
      Sumary: "sum",
      frozen: "frozen",
      alignFrozen: "right",
      hidden: permisoCostos,
    },
    {
      // ISV
      field: "ISV18",
      header: "ISV 18%",
      headerEn: "TAX 18%",
      className: "Xsmall",
      Format: "Currency",
      sortable: true,
      Sumary: "sum",
      frozen: "frozen",
      alignFrozen: "right",
      hidden: permisoCostos,
    },
    {
      // SUBTOTAL
      field: "SubTotal",
      header: "SubTotal",
      className: "small",
      frozen: "frozen",
      alignFrozen: "right",
      Format: "Currency",
      hidden: permisoCostos,
      Sumary: "sum",
    },
    {
      // TOTAL
      field: "Total",
      header: "Total",
      className: "small",
      Format: "Currency",
      frozen: "frozen",
      Sumary: "sum",
      alignFrozen: "right",
      hidden: permisoCostos,
    },
  ];

  const table = {
    Columns: columns,
    Data: detalleOrdenCompra,
    // loading: loading,
    selected: selected,
    setSelected: setSelected,
    ref: dtAutorizarRequisa,
    showModal: (e) => showModal(e),
  };

  const showModal = () => {
    setRequisaDialog(true);
  };
  const RequisaC = (Id) => {
    setRequisaToShow(Id);
    setRequisaDialog(true);
    showModal();
  };

  useEffect(() => {
    resetTable(detalleOrdenCompra);
  }, [detalleOrdenCompra]);

  useEffect(() => {
    obtenerDetalleCustomer();
  }, [values.Cliente]);

  useEffect(() => {
    obtenerInfoInput();
    if (PurchaseOrder) {
      setBotonReporteHabilitado(true);
    } else {
      setBotonReporteHabilitado(false);
    }
  }, [PurchaseOrder]);

  useEffect(() => {
    obtenerInfoInput();
  }, [ordenDialog]);

  const cerrarConfirmacion = () => {
    // Mostrar confirmación si hay ediciones sin guardar
    if (habilitar && requisaToShow !== null) {
      confirmDialog({
        message: "¿Estás seguro de cerrar sin guardar los cambios?",
        header: "Cerrar sin guardar",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sí",
        accept: () => {
          setRequisaDialog(null);
          setRequisaToShow(null); // Cerrar el diálogo
        },
        rejectLabel: "No",
        reject: () => {}, // No hacer nada si el usuario cancela
        style: { backgroundColor: "white" },
      });
    } else {
      setRequisaDialog(null);
      setRequisaToShow(null);
      setHabilitar(true);
    }
  };

  return (
    <div>
      <Toast ref={toast} />
      <Loader loading={loading} />
      <EncabezadoOrdenesCompras
        values={values}
        handleInputChange={handleInputChange}
        habilitar={habilitar}
        clienteDetalles={clienteDetalles}
        setNumber={setNumber}
        Functions={Functions}
        inputValues={inputValues}
        botonReporteHabilitado={botonReporteHabilitado}
        detalleOrdenCompra={detalleOrdenCompra}
      />
      <div style={{ height: "58vh", marginTop: "1rem" }}>
        <AgGrid table={table} />
      </div>

      <Dialog
        visible={requisaDialog}
        onHide={() => {
          cerrarConfirmacion();
        }}
        maximized={true}
        maximizable={true}
        closeOnEscape={false}
      >
        <CrudRequisa
          idRequisa={requisaToShow}
          setRequisaToShow={setRequisaToShow}
          showDialog={requisaDialog}
          // actualizarRequisas={actualizarRequisas}
          // actualizarRequisasScreen={actualizarRequisas}
          setOrderToShow={setOrderToShow}
          setOrdenDialog={setOrdenDialog}
          habilitar={habilitar}
          setHabilitar={setHabilitar}
        />
      </Dialog>
    </div>
  );
};

export default OrdenesComprasCrud;
